<!--
    课程分享-课程批量授权
    作用：校区授权课程
    功能：展示选中课程数据、授权方式、账号选取、课程授权
    说明：版本3.0
-->
<template>
  <div class="steps-wrapper">
    <div class="steps-demo">
      <el-steps
        :active="curStep"
        align-center>
        <el-step title="确认已选课程"/>
        <el-step title="确认授权方式"/>
        <el-step title="选择账号"/>
        <el-step title="完成授权"/>
      </el-steps>
    </div>
    <div class="steps-content">
      <!-- <div class="scroll-content"><auth-table/></div> -->
      <once-step
        v-if="curStep === 1"
        @update-couese="handlerCouese"
        @nextStep="toTwoStep"/>
      <two-step
        v-if="curStep === 2"
        @lastStep="curStep = 1"
        @nextStep="toThreeStep"/>
      <three-step
        v-if="curStep === 3"
        :auth-type="authType"
        @lastStep="curStep = 2"
        @nextStep="curStep = 4"/>
      <four-step
        v-if="curStep === 4"
        :auth-type="authType"
        :sel-course="selCourse"
        @lastStep="curStep = 3"
        @submitData="submitData"/>
    </div>
  </div>
</template>
<script>
import onceStep from './components/onceStep';
import twoStep from './components/twoStep';
import threeStep from './components/threeStep';
import fourStep from './components/fourStep';
import { createAuthInfo } from '@/api/courseOn';

export default {
  name: 'VolumeAuth',
  components: {
    onceStep,
    twoStep,
    threeStep,
    fourStep,
  },
  data() {
    return {
      curStep: 1,
      authType: '1',
      selCourse: [],
    };
  },
  methods: {
    handlerCouese(val) {
      this.selCourse = val;
    },
    toTwoStep() {
      if (this.selCourse.length) {
        this.curStep = 2;
        return;
      }
      this.$message.warning('请选择授权课程！');
    },
    toThreeStep(val) {
      this.curStep = 3;
      this.authType = val;
    },
    submitData() {
      const school_list = [];
      const packet_id_list = [];
      this.$store.state.accountAuth.forEach((item) => {
        let obj = {};
        if (this.authType === '1') {
          const arr = [];
          item.staff_id_list.forEach((v) => {
            arr.push(v.search_staff_id);
          });
          obj = {
            id: item.id,
            staff_id_list: arr,
          };
        } else {
          obj = {
            id: item.id,
            auth_number: item.auth_number,
          };
        }
        school_list.push(obj);
      });
      this.selCourse.forEach((item) => {
        packet_id_list.push(item.id);
      });
      const obj = {
        auth_type: +this.authType,
        school_list,
        packet_id_list,
      };
      const loading = this.$loading({
        lock: true,
        text: '数据提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      createAuthInfo(this.$store.state.choicesSchool.id, obj).then((res) => {
        console.log(res);
        if (res.status_code === 200) {
          this.$message.success('授权成功！');
          this.$store.dispatch('setAccountAuth', []);
          this.$store.dispatch('setCourseAuth', []);
          this.$router.go(-1);
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        loading.close();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.steps-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  flex: none!important;
  .steps-demo {
    width: 70%;
    padding-top: 90px;
    /deep/ .el-step__head.is-finish {
      color: #303133;
      border-color: #d3d8e2;
      .el-step__icon-inner {
        color: #fff;
      }
      .el-step__icon {
        background: #45cb90;
        border-color: #45cb90!important;
      }
    }
    /deep/ .el-step__title.is-finish {
    color: #303133;
    font-weight: 600;
    }
    /deep/ .el-step__icon{
        width: 30px;
        height: 30px;
    }
  }
  .steps-content{
      flex:1;
      width: 100%;
      padding: 0 30px;
      margin: 50px 0 20px 0;
      box-sizing: border-box;
      overflow: hidden;
  }
}
</style>
<style lang="scss">
.el-table::before {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/index.vue